import Vue from 'vue'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en' // 英文语言包
import formCreate from '@form-create/element-ui'

export default () => {
  Vue.use(Element, { /* locale */ zIndex: 10001 });
  Vue.use(formCreate);
}